import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  radio: {
    marginTop: [10, '!important']
  }
})

export default useStyles
